export default "__VITE_ASSET__BjzebA5a__"